import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import Vant from 'vant';
import 'vant/lib/index.css';
import { Toast } from 'vant';

import Container from '@/components/Container.vue'

Vue.use(Vant)
Vue.use(Toast)

Vue.use(VueRouter)
Vue.use(ElementUI);

Vue.component('container', Container)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
